const API_BASE_URL =
    import.meta.env.VITE_PUBLIC_API_URL || 'http://localhost:8080/api';

export { API_BASE_URL };
